import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/bancos/cuentaBancaria';
import Cuentas from './CuentaBancaria';


const ms2p = (state) => {
  return {
    ...state.cuentaBanco,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Cuentas);
